import React from 'react';
import PropTypes from 'prop-types';
import { StyledWrapper } from './Detail.styled';
import { TableView } from '../../../components/StyledLayout/Layout.styled';
import { CupsTableColumn } from './detail.helper';

const CupsHistory = ({ customer }) => {
  const cupsColumns = CupsTableColumn();

  return (
    <StyledWrapper>
      <div className="layout-styled">
        <h2>Cups Total: {customer?.reward?.cups?.products?.total || 0}</h2>
        <TableView
          columns={cupsColumns}
          dataSource={customer?.cupsHistory}
          bordered={false}
          pagination={false}
        />
      </div>
    </StyledWrapper>
  );
};
CupsHistory.propTypes = {
  customer: PropTypes.object,
};

export default CupsHistory;
